import { DateRange } from 'owa-datetime-utils';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

type PopulateDayDataFunction = (
    scenarioId: string,
    newFolderIds?: string[],
    newDateRange?: DateRange,
    newSelectionItem?: CalendarEvent,
    newShowSelectionItem?: boolean
) => void;

const customPopulateDayDataMap: {
    [key: string]: PopulateDayDataFunction;
} = {};

export function getCustomPopulateDayData(scenarioId: string) {
    return customPopulateDayDataMap[scenarioId];
}

export function setCustomPopulateDayData(
    scenarioId: string,
    customPopulateFunction: PopulateDayDataFunction
) {
    customPopulateDayDataMap[scenarioId] = customPopulateFunction;
}
